import React from 'react'
import './contact.css'
import { AiOutlineMail } from 'react-icons/ai'
import { RiMessengerLine } from 'react-icons/ri'
import { BsWhatsapp } from 'react-icons/bs'
import { useRef } from 'react'
import emailjs from 'emailjs-com'
const Contact = () => {
  const form = useRef()
  const sendEmail = (e) => {
    e.preventDefault()

    emailjs.sendForm(
      'service_57t470r',
      'template_d1bln6b',
      form.current,
      'gi3z8fQJ1R0H67SlZ'
    )
    e.target.reset()
  }
  return (
    <section id='contact'>
      <h5>Contactez nous</h5>
      <h2>Nos contacts</h2>

      <div className='container contact_container'>
        <div className='contact_options'>
          <article className='contact_option'>
            <AiOutlineMail className='contact_option-icon'></AiOutlineMail>
            <h4>Email</h4>
            <h5>manguemasysylla13@gmail.com</h5>
            <a href='mailto:manguemasysylla13@gmail.com' target='_blanket'>
              Envoyez un message
            </a>
          </article>
          <article className='contact_option'>
            <RiMessengerLine className='contact_option-icon'></RiMessengerLine>
            <h4>Messanger</h4>
            <h5>Masy design Officiel</h5>
            <a
              href='https://m.me/profile.php?id=100088986715837'
              target='_blanket'
            >
              Envoyez un message
            </a>
          </article>
          <article className='contact_option'>
            <BsWhatsapp className='contact_option-icon'></BsWhatsapp>
            <h4>Whatsapp</h4>
            <h5>+212 680 227 410</h5>
            <a
              href='https://api.whatsapp.com/send?phone=+212680227410'
              target='_blanket'
            >
              Envoyez un message
            </a>
          </article>
        </div>
        {/* END OF CONTACT */}
        <form ref={form} onSubmit={sendEmail}>
          <input
            type='text'
            name='name'
            placeholder='Your full name'
            required
          />
          <input type='email' name='email' placeholder='Your email' required />
          <textarea
            name='message'
            placeholder='Your message'
            rows='10'
          ></textarea>
          <button type='submit' className='btn btn-primary'>
            Envoyez
          </button>
        </form>
      </div>
    </section>
  )
}

export default Contact
